  var swipers = new Swiper(".myswipers", {
    autoplay: false,
    scrollbar: {
      el: ".swiper-scrollbar.sp",
      hide: true,
    },
    spaceBetween: 10,
    loop: true,
  });

  // Popup logic
  document.querySelectorAll('.zoom-btn').forEach(function(button) {
    button.addEventListener('click', function() {
      var imageSrc = this.previousElementSibling.src; // Get image source
      var popupOverlay = document.querySelectorAll('.image-popup-overlay');
      var popupImage = document.querySelector('.popup-image');
        if (window.innerWidth > 749) {
         
          popupOverlay[0].style.display = 'flex'; // Show popup
        }  else {
            
          popupOverlay[1].style.display = 'flex'; // Show popup
        }
       popupImage.src = imageSrc; // Set image source to popup image
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      
    });
  });

 document.querySelectorAll('.close-popup').forEach(function(closePopup) {
  // Close the popup
      closePopup.addEventListener('click', function() {
        if (window.innerWidth > 749) {
          document.querySelectorAll('.image-popup-overlay')[0].style.display = 'none';
        } else {
           document.querySelectorAll('.image-popup-overlay')[1].style.display = 'none';
        }
        document.getElementsByTagName("body")[0].style.overflow = "auto"
      });
 });
  // Close popup when clicking outside the image
document.querySelectorAll('.image-popup-overlay').forEach(function(overlay) {
 overlay.addEventListener('click', function(e) {
    if (e.target === this) {
      this.style.display = 'none';
      document.getElementsByTagName("body")[0].style.overflow = "auto"
    }
  });
    });